var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:[_vm.icon, 'fa-2x p-3 block-icon']})
}
var staticRenderFns = []

export { render, staticRenderFns }